export { default, type TabPaneProps } from './TabPane';
